import { jsx } from "react/jsx-runtime";
import { createContext, useMemo, useEffect, useContext } from "react";
import { productionHades, stagingHades } from "../config.js";
import "../helpers/time.js";
const defaultRedirectUri = typeof window !== "undefined" ? `${window == null ? void 0 : window.location.origin}${window == null ? void 0 : window.location.pathname}` : "";
const defaultSecurityConfig = {
  redirectUri: defaultRedirectUri,
  loginEndpoint: {
    url: "/api/authenticate"
  },
  loginPath: "/login",
  registerPath: "/register",
  successPath: "/",
  twoFactorAuthPath: "/mfa",
  phoneVerificationPath: "/verifyphone",
  emailVerificationPath: "/verifyemail",
  missingConsentsPath: "/renew-consent",
  loading: "Loading...",
  env: "production"
};
const SecurityConfigContext = createContext(defaultSecurityConfig);
const SecurityConfigProvider = ({ children, value = {} }) => {
  const serverUrl = useMemo(() => {
    if (value.endpoint)
      return value.endpoint;
    if (value.env === "development") {
      throw new Error("You need to pass the `endpoint` when the environment is `development`.");
    }
    return value.env === "production" ? productionHades : stagingHades;
  }, [value]);
  useEffect(() => {
    window.hades = {
      serverUrl,
      loginPath: value.loginPath || defaultSecurityConfig.loginPath,
      u_s: value.u_s
    };
  }, [value]);
  return /* @__PURE__ */ jsx(
    SecurityConfigContext.Provider,
    {
      value: {
        ...defaultSecurityConfig,
        ...value
      },
      children
    }
  );
};
const useSecurityConfig = () => {
  const context = useContext(SecurityConfigContext);
  if (!context) {
    throw new Error("useSecurityConfigContext must be used within the securityProvider");
  }
  return context;
};
export {
  SecurityConfigContext,
  SecurityConfigProvider,
  useSecurityConfig
};
